import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CustomErrorHandlerService } from './custom-error-handler.service';
import { AssetService } from './asset.service';
import { SpinnerService } from './spinner.service';
import { AmplifyService } from './amplify.service';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CcmcApiService } from './ccmc-api.service';

@Injectable({
  providedIn: 'root'
})
export class AbrigoSageworksService {
httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json'})
};
abrigoAccessToken: string;
currentLoanKey: string;
  constructor(
    private http: HttpClient,
    private customErrorHandlerService: CustomErrorHandlerService,
    private assetService: AssetService,
    private spinnerService: SpinnerService,
    private amplifyService: AmplifyService,
    private ccmcApiService: CcmcApiService,
    
  ) { 
    this.httpOptions.headers.append('Access-Control-Allow-Origin', '*');
    this.httpOptions.headers.append(
      'Access-Control-Allow-Methods',
      'POST, GET, OPTIONS, PUT'
    );
    this.httpOptions.headers.append('Accept', 'application/json');
  }

  setAccessToken(token: string) {
    this.abrigoAccessToken = token;
  }

   /**
   * Retrieve Files
   * @description displays and sorts the loans, updates the badge count
   * @param {*} callback
   * @memberof BakerhillService
   */
  retrieveFiles(callback: any) {
    this.ccmcApiService.s3ListFiles('abrigo-api-loans').subscribe((res: any) => {
      console.log("This is the result from s3 list files", res);
      if (res) {
        return callback.handleRetrievedFiles(null, res.body);
      }
      const errorMessage = {
        message: 'No files found.',
        title: 'No Results'
      };
      return callback.handleRetrievedFiles(errorMessage, null);
    });
  }

  // //This call is meant for in case we pivot into an encompass like approach when it comes to dealing with loans
  // async loanLookUp(params: { [key: string]: any }) {
  //   let url: any;
  //   params.assetID = this.assetService.getSelectedAssetId();
  //   if(this.abrigoAccessToken) {
  //     params.accessToken = this.abrigoAccessToken;
  //   }

  //   if(params.env === 'Nxtsoft') {
  //     url = 'aHR0cHM6Ly9hcGkubnh0c29mdC5jb20vdjE=';
  //   } else {
  //     url = 'aHR0cHM6Ly9hcGktZGV2Lm54dHNvZnQuY29tL3Yy';
  //   }

  //   this.amplifyService.environmentOverride = true;

  //   return this.http
  //     .post(`${Buffer.from(url, "base64").toString()}/abrigo/search-loans`, params, this.httpOptions)
  //     .pipe(catchError(this.customErrorHandlerService.handleError));
  // }

  // //This call is meant for in case we pivot into an encompass like approach when it comes to dealing with loans
  // async getLoan(params: { [key: string]: any }) {
  //    params.assetID = this.assetService.getSelectedAssetId();
  //    if(this.abrigoAccessToken) {
  //     params.accessToken = this.abrigoAccessToken;
  //   }

  //   return this.http
  //     .post(`${Buffer.from(environment.environmentURL, "base64").toString()}/abrigo/get-loan`, params, this.httpOptions)
  //     .pipe(catchError(this.customErrorHandlerService.handleError));
  // }

    /**
   *
   */
  /**
   * Loan Selected
   * @description gets the loan infomration and returns the populated core mapping
   * @param {*} key
   * @param {*} callback
   * @memberof AbrigoSageworksService
   */
  loanSelected(key: any, callback: any) {
    this.currentLoanKey = key;
    this.ccmcApiService
      .s3GetFile('abrigo-api-loans', key)
      .subscribe((res: any) => {
        if (res.statusFlag) {
          console.log('s3getFile result ', res);
          this.ccmcApiService.ice(res.content).subscribe(
            (response: any) => {
              console.log(response);
              if (response.statusFlag === true) {
                return callback.handleCoreMappingResponse(null, response);
              } else if (response.statusMessage) {
                const errorMessage = {
                  message: response.statusMessage,
                  title: 'Ice Error'
                };
                return callback.handleCoreMappingResponse(errorMessage, null);
              } else {
                const errorMessage = {
                  message: response.errorMessage,
                  title: 'Ice Error'
                };
                return callback.handleCoreMappingResponse(errorMessage, null);
              }
            },
            error => {
              console.log(error);
              const errorMessage = {
                message: error,
                title: 'Ice Error'
              };
              return callback.handleCoreMappingResponse(errorMessage, null);
            }
          );
        } else {
          const errorMessage = {
            message: 'Error Retrieving Loan',
            title: 'Loan Error'
          };
          return callback.handleCoreMappingResponse(errorMessage, null);
        }
      });
  }

  loanBooked(result: any, configurations: any) {
    console.log('configurations', configurations);
    if (!configurations.demoMode && !configurations.implementationMode) {
      // Record Sender
      this.ccmcApiService.recordSender().subscribe(result => {
        console.log(result);
      });
    }
  }
}
